import { apiRequest } from "@/lib/api";

export interface AdminStats {
  teamsCount: number;
  companiesCount: number;
  activeSubscriptions: number;
  dianProcessesLast24h: {
    queued: number;
    processing: number;
    completed: number;
    failed: number;
  };
  lastProcessAt: string | null;
}

export interface HealthResponse {
  status: "ok";
  service: string;
  timestamp: string;
}

export function getAdminStats(): Promise<AdminStats> {
  return apiRequest("/api/admin/stats");
}

export function getHealth(): Promise<HealthResponse> {
  return apiRequest("/health");
}